import React from 'react';
import {injectIntl, intlShape} from 'react-intl';
import Message from './Message'
import Sender from './Sender'
import {FormattedDate} from 'react-intl';
import {isSameDate} from '../common_components/date_functions';
import InfiniteScroll from 'react-infinite-scroller';
import {inject, observer} from "mobx-react";
import Loading from './Loading';


@inject('rootStore') @observer
class Conversation extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      lastScrollPosition: 0,
    };

    this.lastMessageDate = null;
    this.lastScrollPosition = 0;
    this.renderDate = this.renderDate.bind(this);
  }

  componentDidMount() {
    const messagesDiv = this.messagesContainer;
    messagesDiv.scrollTop = messagesDiv.scrollHeight;
  }

  componentWillUpdate(){
    const messagesDiv = this.messagesContainer;
    this.lastScrollPosition = messagesDiv.scrollHeight - messagesDiv.scrollTop;
  }

  componentDidUpdate(){
    const messagesDiv = this.messagesContainer;
    messagesDiv.scrollTop = messagesDiv.scrollHeight - this.lastScrollPosition;
  }

  render(){
    const {conversation} = this.props;
    const renderLoading = conversation.loadingMessages && !conversation.hasMessages;
    const sortedMessages = conversation.sortedMessages;
    
    if( sortedMessages.length > 0 ){
      this.lastMessageDate = sortedMessages[0].updatedAt;
    }
    return(
      <div>
        <div ref={(element) => {this.messagesContainer = element;}} className="messages-container">
          { renderLoading && <Loading /> }
          { !renderLoading && 
              <InfiniteScroll
                    loadMore={() => conversation.loadMoreMessages()} 
                    useWindow={false} 
                    hasMore={conversation.hasUnretrievedMessages} 
                    isReverse 
              >
                {(!conversation.hasUnretrievedMessages) && (this.renderInitialMessage()) }
                {sortedMessages.map( (message) => 
                  <div key={message.id}>
                    {this.renderDate(message)}
                    <Message message={message} 
                      currentUser={this.props.rootStore.user} />
                  </div>
                )}
              </InfiniteScroll>
            }
          </div>  
        { !renderLoading && <Sender conversation={conversation} /> }
      </div>
    );
  }

  renderInitialMessage(){
    if( this.props.conversation.isGroup ){
      return(
      <div className="centered-message">
        <span>
        {this.props.intl.formatMessage(
          { id: "newGroupGreeting" },{ 
            name: this.props.rootStore.user.name,
            groupName: this.props.conversation.subject
          })
        }
        </span>
      </div>);
    }
  }

  renderDate(message){
    let elementToRender = <div></div>
    if( !isSameDate(message.updatedAt, this.lastMessageDate) ){
      elementToRender = <div className="centered-message">
          <FormattedDate value={message.updatedAt} />
        </div>
      this.lastMessageDate = message.updatedAt;
    }
    return elementToRender;
  }
}

export default injectIntl(Conversation);